import React from 'react';
import PropTypes from 'prop-types';
import s from './LoaderSpinner1.scss';

class LoaderSpinner extends React.PureComponent {
  //const { data } = props;
  render() {
    return (
      <span className={`${s.loaderwrapper} ${this.props.overwriteWrapper}`}>
        <span
          className={`${s.loading_spinner} ${this.props.overwriteLoader}`}
        />
      </span>
    );
  }
}

LoaderSpinner.propTypes = {
  overwriteWrapper: PropTypes.string,
  overwriteLoader: PropTypes.string,
};
LoaderSpinner.defaultProps = {
  overwriteWrapper: '',
  overwriteLoader: '',
};

export default LoaderSpinner;
